'use client';

import { createContext } from 'react';

/**
 * Gate a paid-feature action on the creator having Stripe charges enabled.
 * If enabled, `next()` runs immediately; otherwise a confirm dialog prompts the
 * creator to complete/repair Stripe onboarding (routing to `/stripe-connect`)
 * and `next()` does NOT run. Ported from PopshopRN `useEnsureChargesEnabled`.
 */
export type EnsureChargesEnabled = (
  actionLabel: string,
  next: () => void,
) => void;

export interface StripeConnectGateContextValue {
  ensureChargesEnabled: EnsureChargesEnabled;
}

export const StripeConnectGateContext =
  createContext<StripeConnectGateContextValue | null>(null);
